import { MutationTuple, useMutation } from '@apollo/client';
import { AssignCommoditiesInput, AssignCommodityCrewMembersPayload } from '@bechtel/types';
import { ASSIGN_COMMODITY_CREW_MEMBERS } from '@bechtel/client-gql';

export function useAssignCommodityCrewMembers(
  onActionCompleted?: () => void,
  refetchQueries?: string[]
): MutationTuple<
  { assignCommodityCrewMembersPayload: AssignCommodityCrewMembersPayload },
  { input: AssignCommoditiesInput }
> {
  const response = useMutation<
    { assignCommodityCrewMembersPayload: AssignCommodityCrewMembersPayload },
    { input: AssignCommoditiesInput }
  >(ASSIGN_COMMODITY_CREW_MEMBERS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries,
  });
  return response;
}
